import React, { useEffect, useState } from 'react'
import { AiFillMinusCircle } from "react-icons/ai";
import {
    FaCaretUp,
    FaCaretDown,
    FaChevronDown,
    FaChevronUp,
    FaChevronLeft,
    FaChevronRight,
} from "react-icons/fa";
import { Col, Row } from 'reactstrap'
import { useSelector } from 'react-redux';
import { numberWithCommas } from '../../utils/customFunction';
import { IoAddCircle } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
    Dropdown,
    DropdownToggle,
    DropdownItem,
    DropdownMenu,
    NavLink,
} from "reactstrap";

function StockCard(props) {
    const {
        addWatchFlag = false,
        setSearchCompany,
        selectedOpt,
        filterArr,
        setFilterArr,
        list,
        itemsToShow,
        setSelectedItem,
        setModalFlag,
        investmentCal,
        setInvestmentCal,
        setCheckAllShares,
        screen
    } = props
    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
    const [alterList, setAlterList] = useState<any>()
    const [openDropdownIndex, setOpenDropdownIndex] = useState<any>()
    const [progreesBarFlag, setProgreesBarFlag] = useState<boolean>(false)
    const [progressBarData, setProgressBarData] = useState<any>();

    const toggleDropdown = (index) => {
        if (openDropdownIndex === index) {
            setOpenDropdownIndex(null);
        } else {
            setOpenDropdownIndex(index);
        }
    };

    const handleMoveLeft = (index) => {
        if (index > 0) {
            const newList = [...alterList];
            const temp = newList[index];
            newList[index] = newList[index - 1];
            newList[index - 1] = temp;
            setAlterList(newList);

            const updatedFilterArr = filterArr.map((filter) => {
                if (filter.value === selectedOpt) {
                    const updatedList = [...filter.list];
                    const tempItem = updatedList[index];
                    updatedList[index] = updatedList[index - 1];
                    updatedList[index - 1] = tempItem;
                    return { ...filter, list: updatedList };
                }
                return filter;
            });
            setFilterArr(updatedFilterArr);
        }
    };

    const handleMoveRight = (index) => {
        if (index < alterList.length - 1) {
            const newList = [...alterList];
            const temp = newList[index];
            newList[index] = newList[index + 1];
            newList[index + 1] = temp;
            setAlterList(newList);

            const updatedFilterArr = filterArr.map((filter) => {
                if (filter.value === selectedOpt) {
                    const updatedList = [...filter.list];
                    const tempItem = updatedList[index];
                    updatedList[index] = updatedList[index + 1];
                    updatedList[index + 1] = tempItem;
                    return { ...filter, list: updatedList };
                }
                return filter;
            });
            setFilterArr(updatedFilterArr);
        }
    };

    useEffect(() => {
        setAlterList(list?.slice(0, itemsToShow))
    }, [list, itemsToShow])

    const getImageSrc = (symbol: string) => {
        try {
            return require(`../../assets/psxLogos/${symbol}.png`).default;
        } catch (e) {
            return require(`../../assets/psxLogos/0.png`).default;
        }
    };

    const handleTableCellClick = (
        index,
        barWidth,
        barBottomGap,
        LowerLimitRange,
        UpperLimitRange,
        currentRateIndicator,
        OpenRateIndicator,
        item
    ) => {
        setProgressBarData({
            index,
            barWidth,
            barBottomGap,
            LowerLimitRange,
            UpperLimitRange,
            currentRateIndicator,
            OpenRateIndicator,
            item
        });
        setProgreesBarFlag(true);
    };

    const fetchProgressBar = (
        index,
        barWidth,
        barBottomGap,
        LowerLimitRange,
        UpperLimitRange,
        currentRateIndicator,
        OpenRateIndicator,
        item,
    ) => {
        return (
            <>
                <div
                    className='d-flex flex-column justify-content-between mr-1 position-relative'
                    style={{
                        width: "inherit"
                    }}
                >
                    <small
                        id='progreesBar'
                        data-toggle="tooltip"
                        data-placement="top"
                        title={`UL-${UpperLimitRange}`}
                        className={`smallTagColor-${theme}`} >
                        <span
                            className='span_progress_val'>
                            {/* UL- */}
                            UL{' '}
                        </span>
                        {
                            UpperLimitRange
                        }
                    </small>
                    <small
                        id='progreesBar'
                        data-toggle="tooltip"
                        data-placement="top"
                        title={`LL-${LowerLimitRange}`}
                        className={`smallTagColor-${theme}`}
                    >
                        <span
                            className='span_progress_val'
                        >
                            {/* LL- */}
                            LL{' '}
                        </span>
                        {
                            LowerLimitRange
                        }
                    </small>
                </div>

                <div
                    style={{
                        height: "inherit",
                        maxWidth: "9px",
                        overflow: "visible",
                        background: "linear-gradient(90deg, rgba(198,252,210,1) 0%, rgba(252,232,221,1) 100%)"
                    }}
                    className="progress position-relative">
                    <div
                        className="progress-bar position-absolute"
                        role="progressbar"
                        style={{
                            width: "100%",
                            height: `${Math.min(barWidth, 100)}%`,
                            minHeight: "8%",
                            border: "1px solid",
                            borderRadius: "12px",
                            left: "0%",
                            bottom: `${barBottomGap}%`,
                            backgroundColor: (barBottomGap <= 5 && Math.min(barWidth, 100) <= 5) ? "rgb(222, 79, 69)" :
                                (barBottomGap <= 10 && Math.min(barWidth, 100) <= 10) ? "rgb(222 79 69 / 59%)" :
                                    (barBottomGap <= 30 && Math.min(barWidth, 100) <= 30) ? "rgb(23 173 226)" : (barBottomGap <= 40 && Math.min(barWidth, 100) <= 40) ? "rgb(122, 198, 225)" : "rgb(5, 189, 100)",
                            overflow: "visible"
                        }}
                    >
                        <div
                            style={{
                                width: "fit-content"
                            }}
                            className='position-relative h-100'
                        >
                            <div
                                style={{
                                    position: "absolute",
                                    right: "-6px",
                                    bottom: `${Math.min(currentRateIndicator, 100 - barWidth == 0 ? 5 : barWidth)}%`,
                                    lineHeight: "15px",
                                    zIndex: 34
                                }}
                                className='d-flex align-items-center'>
                                <small
                                    id='progreesBar'
                                    className={`smallTagColor-${theme}`}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title={`OR-${item?.open_price}`}
                                >
                                    <span
                                        style={{
                                            marginRight: "2px"
                                        }}
                                        className='span_progress_val'>
                                        {/* OR- */}
                                        OR{' '}
                                    </span>
                                    <small
                                        className='color_valu'
                                    >
                                        {item?.open_price}
                                    </small>
                                </small>
                                <FaCaretDown
                                    className='text-primary'
                                    style={{
                                        transform: "rotate(270deg)"
                                    }}
                                />
                            </div>
                            <div
                                style={{
                                    position: "absolute",
                                    bottom: `${Math.min(OpenRateIndicator, 100 - barWidth == 0 ? 5 : barWidth)}%`,
                                    left: "0px",
                                    lineHeight: "15px",
                                    zIndex: 34
                                }}
                                className='d-flex align-items-center'>
                                <FaCaretUp
                                    className='text-primary'
                                    style={{
                                        transform: "rotate(270deg)"
                                    }}
                                />
                                <small
                                    id='progreesBar'
                                    className={`smallTagColor-${theme}`}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title={`CR-${item?.current_price}`}
                                >
                                    <span
                                        style={{ marginRight: "2px" }}
                                        className='span_progress_val'>
                                        {/* CR- */}
                                        CR{' '}
                                    </span>
                                    <small
                                        style={{
                                            color: index == 0 ? "#15c46f" : "#f8a774"
                                        }}
                                        className='color_valu'
                                    >
                                        {item?.current_price}
                                    </small>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='d-flex flex-column justify-content-between ml-1 position-relative' style={{ width: "inherit" }}>
                    <small
                        // style={{ writingMode: "vertical-lr" }}
                        id='progreesBar'
                        data-toggle="tooltip" data-placement="top" title={`HR-${item?.high_price}`}
                        className={`smallTagColor-${theme}`}>
                        <span
                            className='span_progress_val'>
                            {/* HR- */}
                            HR{' '}
                        </span>
                        <small
                            className='color_valu'
                            style={{ color: "#12c36d" }} >
                            {item?.high_price}
                        </small>
                    </small>
                    <small
                        // style={{ writingMode: "vertical-lr" }}
                        id='progreesBar'
                        data-toggle="tooltip" data-placement="top" title={`LR-${item?.low_price}`}
                        className={`smallTagColor-${theme}`}>
                        <span
                            className='span_progress_val'>
                            {/* LR- */}
                            LR{' '}
                        </span>
                        <small
                            className='color_valu'
                            style={{ color: "#f8a774" }}>
                            {item?.low_price}
                        </small>
                    </small>
                </div>
            </>
        )
    }

    return (
        <>
            <Modal
                dialogClassName="modal90w"
                centered={true}
                show={progreesBarFlag}
                size="lg"
                backdrop={true}
                onHide={() => {
                    setProgreesBarFlag(false);
                }}
            >
                <div className={`modal-header p-3 `}>
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => {
                            setProgreesBarFlag(false);
                        }}
                    >
                        <i className="tim-icons icon-simple-remove text-white" />
                    </button>
                    <h6 className="title title-up">
                        OGCL Rate Fluctuation
                    </h6>
                </div>
                <div className="modal-body">
                    <div
                        style={{
                            minHeight: "200px"
                        }}
                        className='d-flex justify-content-start'>
                        {fetchProgressBar(
                            progressBarData?.index,
                            progressBarData?.barWidth,
                            progressBarData?.barBottomGap,
                            progressBarData?.LowerLimitRange,
                            progressBarData?.UpperLimitRange,
                            progressBarData?.currentRateIndicator,
                            progressBarData?.OpenRateIndicator,
                            progressBarData?.item,
                        )}
                    </div>
                    <div className="d-flex flex-wrap mt-3">
                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>High Rate</small>
                                <div className="text-primary table_heading_large">
                                    {progressBarData?.item?.high_price || 0}
                                </div>
                            </div>
                        </div>

                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>Low Rate</small>
                                <div className="text-primary table_heading_large">
                                    {progressBarData?.item?.low_price || 0}
                                </div>
                            </div>
                        </div>

                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>Current Rate</small>
                                <div className="text-primary table_heading_large">
                                    {progressBarData?.item?.current_price || 0}
                                </div>
                            </div>
                        </div>

                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>Open Rate</small>
                                <div className="text-primary table_heading_large">
                                    {progressBarData?.item?.open_price || 0}
                                </div>
                            </div>
                        </div>

                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>Lower Limit</small>
                                <div className="text-primary table_heading_large">
                                    {progressBarData?.LowerLimitRange || 0}
                                </div>
                            </div>
                        </div>

                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>Upper Limit</small>
                                <div className="text-primary table_heading_large">
                                    {progressBarData?.UpperLimitRange || 0}
                                </div>
                            </div>
                        </div>

                        <div className={`flex-fill p-2 ${screen <= 500 ? 'w-50' : ''}`}>
                            <div style={{ lineHeight: 'normal' }} className="d-flex flex-column">
                                <small style={{ fontSize: '14px' }}>Volume</small>
                                <div className="text-primary table_heading_large">
                                    {numberWithCommas(progressBarData?.item?.volume || 0)}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="table-responsive mt-2">
                        <table
                            className="table mt-0">
                            <tbody>
                                <tr>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                High Rate
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {progressBarData?.item?.high_price || 0}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                Low Rate
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {progressBarData?.item?.low_price || 0}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                Current Rate
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {progressBarData?.item?.current_price || 0}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                Open Rate
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {progressBarData?.item?.open_price || 0}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                Lower Limit
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {progressBarData?.LowerLimitRange || 0}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                Upper Limit
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {progressBarData?.UpperLimitRange || 0}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div
                                            style={{
                                                lineHeight: "normal"
                                            }}
                                            className='d-flex flex-column'>
                                            <small
                                                style={{
                                                    fontSize: "14px"
                                                }}
                                            >
                                                Volume
                                            </small>
                                            <div className='text-primary table_heading_large'>
                                                {numberWithCommas(progressBarData?.item?.volume || 0)}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
                </div>
            </Modal>
            <Row
                className='pt-3'
            >
                {alterList?.slice(0, itemsToShow)?.map((item, index) => {
                    const UpperLimit: any = item?.ldcp !== 0 ? ((item?.ldcp * 0.1) < 1 ? (item?.ldcp + 1) : (item?.ldcp * 1.1)) : 0
                    const LowerLimit: any = item?.ldcp !== 0 ? ((item?.ldcp * 0.1) < 1 ? (item?.ldcp - 1) : (item?.ldcp * 0.9)) : 0
                    const UpperLimitRange: any =
                        item?.ldcp <= 10 ?
                            (item?.ldcp + 1)?.toFixed(2) :
                            (UpperLimit)?.toFixed(2)

                    const LowerLimitRange: any =
                        item?.ldcp <= 10 ?
                            (item?.ldcp - 1)?.toFixed(2) :
                            (LowerLimit)?.toFixed(2)

                    const barWidth: any =
                        ((item?.high_price - item?.low_price) / (Number(UpperLimitRange) - Number(LowerLimitRange))) * 100

                    // const barWidth: any =
                    //     (item?.high_price + item?.low_price) == 0 ? 1 :
                    //         ((UpperLimitRange - LowerLimitRange) / (item?.high_price + item?.low_price)) * 100


                    const leftPercentBar: any =
                        (((item?.low_price - LowerLimitRange) / (UpperLimitRange - LowerLimitRange)) * 100)?.toString()?.replace("-", "")

                    // const barBottomGap: any = `${Math.min(barWidth, 100) == 100 ? 0 : Math.min(leftPercentBar, 100 - barWidth == 0 ? 8 : barWidth)}`

                    const maxBarWidth = Math.min(Number(barWidth), 100);
                    const isBarWidthMaxed = maxBarWidth === 100;
                    const availableSpace = 100 - maxBarWidth;

                    const barBottomGap: any = isBarWidthMaxed ? 0 : Math.min(Number(leftPercentBar), availableSpace === 0 ? 8 : Math.min(Number(barWidth), availableSpace));

                    // const leftPercentBar: any =
                    //     barWidth == 0 ? 0 :
                    //         (((LowerLimitRange - item?.low_price) / barWidth) * 100)?.toString()?.replace("-", "")

                    // const currentRateIndicator: any =
                    //     item?.current_price < item?.open_price ? (Math.min(leftPercentBar, 100 - barWidth == 0 ? 5 : barWidth) - 2) : ((Math.min(leftPercentBar, 100 - barWidth == 0 ? 5 : barWidth) + Number(barWidth == 0 ? 5 : barWidth)) - 6)

                    // const OpenRateIndicator: any =
                    //     item?.current_price > item?.open_price ? (Math.min(leftPercentBar, 100 - barWidth == 0 ? 5 : barWidth) - 2) : ((Math.min(leftPercentBar, 100 - barWidth == 0 ? 5 : barWidth) + Number(barWidth == 0 ? 5 : barWidth)) - 6)

                    const priceRange = item?.high_price - item?.low_price;

                    const currentRateIndicator: any = priceRange > 0
                        ? ((item?.current_price - item?.low_price) / priceRange) * barWidth
                        : 0;

                    const OpenRateIndicator: any = priceRange > 0
                        ? ((item?.open_price - item?.low_price) / priceRange) * barWidth
                        : 0;
                    // const currentRateIndicator: any = ((item?.current_price - item?.low_price) / (item?.high_price - item?.low_price) * barWidth)
                    // const OpenRateIndicator: any = ((item?.open_price - item?.low_price) / (item?.high_price - item?.low_price) * barWidth)

                    // const currentRateIndicator: any = ((item?.low_price + item?.high_price)) == 0 ? 0 : (item?.current_price / (item?.low_price + item?.high_price)) * 100
                    // const OpenRateIndicator: any = (item?.low_price + item?.high_price) == 0 ? 0 : (item?.open_price / (item?.low_price + item?.high_price)) * 100
                    return (
                        <Col
                            lg="4"
                            xl="2"
                            md="4"
                            className={`mb-5 ${screen <= 500 ? "pb-3 border-bottom" : ""}`}>
                            <div
                                style={{
                                    rowGap: "10px",
                                    borderRadius: "15px",
                                    border: "1px solid #1d8cf8 ",
                                    minHeight: "880px"
                                }}
                                className='d-flex flex-column align-items-center text-center py-2 shadow'>
                                {addWatchFlag && (
                                    <div className='d-flex align-items-baseline'>
                                        {filterArr?.some(ele => ele.value === selectedOpt && ele.list.some(existingItem => existingItem.symbol === item.symbol)) && (
                                            <div
                                                style={{
                                                    minWidth: "90px",
                                                    maxWidth: "90px",
                                                    border: `1px solid ${theme == "dark" ? "#2b3553" : "rgba(29, 37, 59, 0.5)"}`,
                                                    borderRadius: "18px"
                                                }}
                                                className='position-relative pl-4 mb-2'
                                            >
                                                Watch
                                                <AiFillMinusCircle
                                                    onClick={() => {
                                                        const index = filterArr?.findIndex((ele) => ele?.value === selectedOpt);
                                                        if (index !== -1) {
                                                            let temp = [...filterArr];
                                                            if (temp[index]) {
                                                                temp[index].list = temp[index].list.filter(existingItem => existingItem.symbol !== item.symbol);
                                                            }
                                                            setFilterArr(temp);
                                                            setSearchCompany("");
                                                        }
                                                    }}
                                                    className='text-primary'
                                                    style={{
                                                        position: "absolute",
                                                        left: "-9px",
                                                        top: "-2px",
                                                        width: "30px",
                                                        height: "30px",
                                                        cursor: "pointer"
                                                    }}
                                                />
                                            </div>
                                        )}

                                        {!filterArr?.some(ele => ele.value === selectedOpt && ele.list.some(existingItem => existingItem.symbol === item.symbol)) && (
                                            <div
                                                style={{
                                                    minWidth: "90px",
                                                    maxWidth: "90px",
                                                    border: `1px solid ${theme == "dark" ? "#2b3553" : "rgba(29, 37, 59, 0.5)"}`,
                                                    borderRadius: "18px"
                                                }}
                                                className='position-relative mb-1 ml-3 pl-4'
                                            >
                                                Watch
                                                <IoAddCircle
                                                    onClick={() => {
                                                        const index = filterArr?.findIndex((ele) => ele?.value === selectedOpt);
                                                        if (index !== -1) {
                                                            let temp = [...filterArr];
                                                            if (temp[index]) {
                                                                if (!temp[index].list.some(existingItem => existingItem.symbol === item.symbol)) {
                                                                    temp[index].list.push(item);
                                                                }
                                                            }
                                                            setFilterArr(temp);
                                                            setSearchCompany("");
                                                        }
                                                    }}
                                                    className='text-info'
                                                    style={{
                                                        position: "absolute",
                                                        left: "-9px",
                                                        top: "-2px",
                                                        width: "30px",
                                                        height: "30px",
                                                        cursor: "pointer"
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}
                                <img
                                    src={getImageSrc(item?.symbol)}
                                    width={50}
                                    height={50}
                                    style={{
                                        objectFit: "contain",
                                        objectPosition: "center"
                                    }}
                                />
                                <div
                                    style={{
                                        lineHeight: "normal"
                                    }}
                                    className='d-flex flex-column w-100'>
                                    <p
                                        style={{
                                            fontWeight: 600
                                        }}
                                        className='mb-0 text-primary table_heading_large'
                                    >
                                        {item?.symbol}
                                    </p>
                                    <small
                                        style={{
                                            whiteSpace: "break-spaces"
                                        }}
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title={item?.name}
                                        className='text-info'
                                    >
                                        {item?.name}
                                    </small>
                                </div>
                                <div
                                    style={{
                                        lineHeight: "normal"
                                    }}
                                    className='d-flex flex-column align-items-center w-100'>
                                    <small
                                        style={{
                                            opacity: "0.4"
                                        }}
                                        className={`smallTagColor-${theme}`}>
                                        Rate
                                    </small>
                                    <p
                                        style={{
                                            fontWeight: 600,
                                            whiteSpace: "break-spaces"
                                        }}
                                        className='mb-0 text-primary table_heading_large'>
                                        <small
                                            className='xSmall'
                                        >
                                            Rs.
                                        </small>
                                        {
                                            item?.current_price?.toString()?.includes(".") ?
                                                item?.current_price?.toString()?.split(".")[0] :
                                                item?.current_price
                                        }
                                        <small className='xSmall'>
                                            .{
                                                item?.current_price?.toString()?.includes(".") ?
                                                    item?.current_price?.toString()?.split(".")[1] :
                                                    "00"
                                            }
                                        </small>
                                    </p>
                                    <small
                                        className='text-info'
                                    >
                                        Per Share
                                    </small>
                                </div>

                                <div
                                    onClick={() => handleTableCellClick(
                                        index,
                                        barWidth,
                                        barBottomGap,
                                        LowerLimitRange,
                                        UpperLimitRange,
                                        currentRateIndicator,
                                        OpenRateIndicator,
                                        item,
                                    )}
                                    style={{
                                        minHeight: "175px",
                                        minWidth: "112px"
                                    }}
                                    className='d-flex justify-content-center my-2'
                                >
                                    {fetchProgressBar(
                                        index,
                                        barWidth,
                                        barBottomGap,
                                        LowerLimitRange,
                                        UpperLimitRange,
                                        currentRateIndicator,
                                        OpenRateIndicator,
                                        item,
                                    )}
                                </div>

                                <div
                                    style={{
                                        lineHeight: "normal"
                                    }}
                                    className='d-flex flex-column align-items-center w-100'>
                                    <small
                                        style={{
                                            opacity: "0.4"
                                        }}
                                        className={`smallTagColor-${theme}`}
                                    >
                                        Change
                                    </small>
                                    <p
                                        style={{
                                            fontWeight: 600,
                                            whiteSpace: "break-spaces",
                                            color: item?.change > 0 ?
                                                "#05bd64" :
                                                item?.change < 0 ?
                                                    "#de4f45" :
                                                    "#7ac6e1"
                                        }}
                                        className='mb-0 table_heading_large'>
                                        <small
                                            className='xSmall'
                                        >
                                            Rs.
                                        </small>
                                        {item?.change?.toString()?.split(".")[0]}
                                        <small
                                            className='xSmall'
                                        >
                                            .{item?.change?.toString()?.split(".")[1] || "00"}
                                        </small>
                                    </p>
                                    <small
                                        style={{
                                            color: Number(item?.change_percent?.replace("%", "")) > 0 ?
                                                "#05bd64" :
                                                Number(item?.change_percent?.replace("%", "")) < 0 ?
                                                    "#de4f45" :
                                                    "#7ac6e1"
                                        }}
                                    >
                                        {item?.change_percent}
                                    </small>
                                </div>
                                <div
                                    style={{
                                        lineHeight: "normal"
                                    }}
                                    className='d-flex flex-column align-items-center w-100'>
                                    <small
                                        style={{
                                            opacity: "0.4"
                                        }}
                                        className={`smallTagColor-${theme}`}>
                                        Total Volume
                                    </small>
                                    <p
                                        style={{
                                            fontWeight: 600,
                                            whiteSpace: "break-spaces"
                                        }}
                                        className='mb-0 table_heading_large text-primary'>
                                        {numberWithCommas(item?.volume)}
                                    </p>
                                    <small
                                        className='text-info'
                                    >
                                        Shares
                                    </small>
                                </div>
                                <div
                                    style={{
                                        lineHeight: "normal"
                                    }}
                                    className='d-flex flex-column align-items-center w-100'>
                                    <small
                                        style={{
                                            opacity: "0.4"
                                        }}
                                        className={`smallTagColor-${theme}`}
                                    >
                                        Buyer Rate/Volume
                                    </small>
                                    <p
                                        style={{
                                            fontWeight: 600
                                        }}
                                        className='mb-0 text-primary table_heading_large'>
                                        <small
                                            className='xSmall'
                                        >
                                            Rs.
                                        </small>
                                        {
                                            numberWithCommas(item?.bidPrice?.toString()?.includes(".") ?
                                                item?.bidPrice?.toString()?.split(".")[0] :
                                                item?.bidPrice)
                                        }
                                        <small className='xSmall'>
                                            .{
                                                item?.bidPrice?.toString()?.includes(".") ?
                                                    item?.bidPrice?.toString()?.split(".")[1] :
                                                    "00"
                                            }
                                        </small>
                                    </p>
                                    <small
                                        className='text-info small_heading'
                                    >
                                        {numberWithCommas(item?.bidVol || 0)}{" "}Shares
                                    </small>
                                </div>

                                <div
                                    style={{
                                        lineHeight: "normal"
                                    }}
                                    className='d-flex flex-column align-items-center w-100'
                                >
                                    <small
                                        style={{
                                            opacity: "0.4"
                                        }}
                                        className={`smallTagColor-${theme}`}
                                    >
                                        Seller Rate/Volume
                                    </small>
                                    <p
                                        style={{
                                            fontWeight: 600
                                        }}
                                        className='mb-0 text-primary table_heading_large'>
                                        <small
                                            className='xSmall'
                                        >
                                            Rs.
                                        </small>
                                        {
                                            numberWithCommas(item?.offerPrice?.toString()?.includes(".") ?
                                                item?.offerPrice?.toString()?.split(".")[0] :
                                                item?.offerPrice)
                                        }
                                        <small className='xSmall'>
                                            .{
                                                item?.offerPrice?.toString()?.includes(".") ?
                                                    item?.offerPrice?.toString()?.split(".")[1] :
                                                    "00"
                                            }
                                        </small>
                                    </p>
                                    <small
                                        className='text-info small_heading'
                                    >
                                        {numberWithCommas(item?.offerVol || 0)}{" "}Shares
                                    </small>
                                </div>

                                <div className='d-flex flex-column align-items-center mx-3 mt-1'>
                                    <small
                                        style={{
                                            opacity: "0.4"
                                        }}
                                        className={`smallTagColor-${theme}`}>
                                        Investment Calc
                                    </small>
                                    <div className="input-group mb-1">
                                        <span
                                            style={{
                                                maxHeight: "29px"
                                            }}
                                            className={`custom-input-group-${theme} py-1`}>
                                            Rs.
                                        </span>
                                        <input
                                            value={investmentCal[index]?.Rs}
                                            type="text"
                                            className={`form-control text-center customInput-${theme} py-1`}
                                            onChange={(e) => {
                                                let InputVal = e.target.value
                                                if (/^\d+(\.\d{0,2})?$/.test(InputVal) || InputVal === '') {
                                                    let temp: any = [...investmentCal]
                                                    let newRsValue = InputVal ? InputVal : Number(temp[index]?.Rs || 0)
                                                    let calculated = Number(newRsValue) / Number(item?.current_price)
                                                    temp[index] = {
                                                        Rs: InputVal,
                                                        Shares: InputVal ? calculated?.toFixed(0) : ""
                                                    }
                                                    setInvestmentCal(temp)
                                                }
                                            }}
                                        />
                                        <span
                                            style={{
                                                maxHeight: "29px"
                                            }}
                                            className={`custom-input-group-right-${theme} py-1`}>
                                            <FaChevronUp
                                                style={{
                                                    cursor: "pointer",
                                                    height: "12px",
                                                    width: "12px"
                                                }}
                                                onClick={() => {
                                                    let temp: any = [...investmentCal]
                                                    let newRsValue = (Number(temp[index]?.Rs || 0) + 1).toFixed(2);
                                                    let calculated = Number(newRsValue) / Number(item?.current_price);
                                                    temp[index] = {
                                                        Rs: newRsValue,
                                                        Shares: Number(calculated)?.toFixed(0)
                                                    }
                                                    setInvestmentCal(temp)
                                                }}
                                            />
                                            <FaChevronDown
                                                style={{
                                                    cursor: "pointer",
                                                    height: "12px",
                                                    width: "12px"
                                                }}
                                                onClick={() => {
                                                    let temp: any = [...investmentCal]
                                                    if (temp[index]?.Rs > 0) {
                                                        let newRsValue = (Number(temp[index]?.Rs || 0) - 1).toFixed(2);
                                                        let calculated = Number(newRsValue) / Number(item?.current_price);
                                                        temp[index] = {
                                                            Rs: newRsValue,
                                                            Shares: calculated?.toFixed(0)
                                                        }
                                                        setInvestmentCal(temp)
                                                    }
                                                }}
                                            />
                                        </span>
                                    </div>
                                    <div className="input-group mb-0">
                                        <span
                                            style={{
                                                maxHeight: "29px"
                                            }}
                                            className={`custom-input-group-${theme} py-1`}>
                                            Shares
                                        </span>
                                        <input
                                            type="text"
                                            value={investmentCal[index]?.Shares}
                                            className={`form-control text-center customInput-${theme} py-1`}
                                            onChange={(e) => {
                                                let inputVal = e.target.value
                                                if (/^\d*$/.test(inputVal)) {
                                                    let temp: any = [...investmentCal]
                                                    let newShareValue = inputVal ? inputVal : Number(e.target.value || 0)
                                                    let calculated = Number(newShareValue) * Number(item?.current_price)
                                                    temp[index] = {
                                                        Rs: inputVal ? (calculated)?.toFixed(2) : "",
                                                        Shares: inputVal
                                                    }
                                                    setInvestmentCal(temp)
                                                }
                                            }}
                                        />
                                        <span
                                            style={{
                                                maxHeight: "29px"
                                            }}
                                            className={`custom-input-group-right-${theme} py-1`}>
                                            <FaChevronUp
                                                style={{
                                                    cursor: "pointer",
                                                    height: "12px",
                                                    width: "12px"
                                                }}
                                                onClick={() => {
                                                    let temp: any = [...investmentCal]
                                                    if (temp[index]?.Rs > 0) {
                                                        let newShares = (Number(temp[index]?.Shares || 0) + 1);
                                                        let calculated = newShares * Number(item?.current_price);
                                                        temp[index] = {
                                                            Rs: calculated ? calculated?.toFixed(2) : 100000,
                                                            Shares: newShares?.toFixed(0)
                                                        }
                                                        setInvestmentCal(temp)
                                                    }
                                                }}
                                            />
                                            <FaChevronDown
                                                style={{
                                                    cursor: "pointer",
                                                    height: "12px",
                                                    width: "12px"
                                                }}
                                                onClick={() => {
                                                    let temp: any = [...investmentCal]
                                                    if (temp[index]?.Shares > 0) {
                                                        let newShares = (Number(temp[index]?.Shares) - 1);
                                                        let calculated = newShares * Number(item?.current_price);
                                                        temp[index] = {
                                                            Rs: calculated > 0 ? calculated?.toFixed(2) : 100000,
                                                            Shares: newShares?.toFixed(0)
                                                        }
                                                        setInvestmentCal(temp)
                                                    }
                                                }}
                                            />
                                        </span>
                                    </div>
                                </div>
                                <div className='d-flex flex-column align-items-center mx-3 mt-1'>
                                    <small
                                        style={{
                                            opacity: "0.4"
                                        }}
                                        className={`smallTagColor-${theme}`}
                                    >
                                        Action
                                    </small>
                                    <div className={`d-flex align-items-center ${(selectedOpt == "Watch" || selectedOpt == "Portfolio") ? "" : "ml-4"}`}>
                                        <div className='d-flex flex-column mr-0'>
                                            <div
                                                style={{
                                                    maxWidth: "80px",
                                                    border: `1px solid ${theme == "dark" ? "#2b3553" : "rgba(29, 37, 59, 0.5)"}`,
                                                    borderRadius: "18px"
                                                }}
                                                className='position-relative mb-1 pl-2'
                                            >
                                                BUY
                                                <IoAddCircle
                                                    onClick={() => {
                                                        setModalFlag("Buy")
                                                        setSelectedItem({
                                                            ...item,
                                                            market_rate: item?.current_price,
                                                            current_price: item?.bidPrice,
                                                            amount: Number(item?.bidPrice * Number(investmentCal[index]?.Shares))?.toFixed(2),
                                                            quantity: investmentCal[index]?.Shares
                                                        })
                                                    }}
                                                    className='text-info'
                                                    style={{
                                                        position: "absolute",
                                                        left: "-9px",
                                                        top: "-2px",
                                                        width: "30px",
                                                        height: "30px",
                                                        cursor: "pointer"
                                                    }}
                                                />

                                            </div>
                                            {item?.holding && <div
                                                style={{
                                                    maxWidth: "80px",
                                                    border: `1px solid ${theme == "dark" ? "#2b3553" : "rgba(29, 37, 59, 0.5)"}`,
                                                    borderRadius: "18px"
                                                }}
                                                className='position-relative pl-2'
                                            >
                                                SELL
                                                <AiFillMinusCircle
                                                    onClick={() => {
                                                        setModalFlag("Sell")
                                                        setCheckAllShares(true)
                                                        setSelectedItem({
                                                            ...item,
                                                            market_rate: item?.current_price,
                                                            current_price: item?.offerPrice,
                                                            amount: (Number(item?.offerPrice) * Number(item?.holding))?.toFixed(2),
                                                            quantity: item?.holding
                                                        })
                                                    }}
                                                    className='text-primary'
                                                    style={{
                                                        position: "absolute",
                                                        left: "-9px",
                                                        top: "-2px",
                                                        width: "30px",
                                                        height: "30px",
                                                        cursor: "pointer"
                                                    }}
                                                />
                                            </div>}
                                        </div>
                                        {(selectedOpt == "Watch" || selectedOpt == "Portfolio") ?
                                            null
                                            :
                                            <>
                                                <Dropdown
                                                    isOpen={openDropdownIndex === index}
                                                    toggle={() => toggleDropdown(index)}
                                                    className='mx-0 mb-1' nav>
                                                    <DropdownToggle
                                                        caret
                                                        color="default"
                                                        nav
                                                        onClick={(e) => e.preventDefault()}
                                                    >
                                                        <BsThreeDotsVertical />
                                                    </DropdownToggle>
                                                    <DropdownMenu
                                                        style={{ background: theme === "dark" ? "#1e1e2f" : "" }}
                                                        className="dropdown-navbar py-0"
                                                        right
                                                        tag="ul"
                                                    >
                                                        <NavLink className='p-0' tag="li">
                                                            <DropdownItem
                                                                onClick={() => handleMoveLeft(index)}
                                                                className='w-100 mt-0' style={{ borderBottom: "1px solid" }}>
                                                                Move Left
                                                            </DropdownItem>
                                                            <DropdownItem
                                                                onClick={() => handleMoveRight(index)}
                                                                className='w-100 mt-0' style={{ borderBottom: "1px solid" }}>
                                                                Move Right
                                                            </DropdownItem>
                                                        </NavLink>
                                                    </DropdownMenu>
                                                </Dropdown>

                                            </>

                                        }
                                    </div>
                                </div>

                            </div>
                        </Col>
                    )
                })}
            </Row>
        </>
    )
}

export default StockCard